import styled from 'styled-components'

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StepWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const StepBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const Circle = styled.div<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  border: 1px solid ${({ selected }) => (selected ? '#1C1D22' : '#C6C6C6')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::after {
    content: '';
    width: 4px;
    height: 4px;
    background-color: ${({ selected }) =>
      selected ? '#1C1D22' : 'transparent'};
    border-radius: 50%;
  }
`

export const Label = styled.span<{ selected: boolean }>`
  font-size: 12px;
  position: absolute;
  bottom: -8px;
  transform: translateY(100%);
  color: ${({ selected }) => (selected ? '#757575' : '#CCCCCC')};
  text-align: center;
`

export const Line = styled.div`
  height: 1px;
  background-color: #ccc;
  width: 40px;
  width: 160px;
`
